import { httpClient } from '../api/http.client';
import {
  OrderListResponse,
  OrderFilters,
  OrderDetailResponse,
  UpdateOrderStatusDto,
  UpdateOrderCommentDto,
  CreateOrderDto,
} from '@/domain/entities';

export class OrderRepository {
  async getAll(filters: OrderFilters = {}): Promise<OrderListResponse> {
    const params = new URLSearchParams();

    if (filters.limit) params.append('limit', filters.limit.toString());
    if (filters.offset) params.append('offset', filters.offset.toString());
    if (filters.status) params.append('status', filters.status);
    if (filters.search) params.append('search', filters.search);
    if (filters.userId) params.append('userId', filters.userId);
    if (filters.dateFrom) params.append('dateFrom', filters.dateFrom);
    if (filters.dateTo) params.append('dateTo', filters.dateTo);

    const queryString = params.toString();

    return httpClient.get<OrderListResponse>(
      `/api/admin/orders${queryString ? `?${queryString}` : ''}`
    );
  }

  async getById(id: string): Promise<OrderDetailResponse> {
    return httpClient.get<OrderDetailResponse>(`/api/admin/orders/${id}`);
  }

  async updateStatus(id: string, payload: UpdateOrderStatusDto): Promise<OrderDetailResponse> {
    return httpClient.patch<OrderDetailResponse>(`/api/admin/orders/${id}/status`, payload);
  }

  async updateComment(id: string, payload: UpdateOrderCommentDto): Promise<OrderDetailResponse> {
    return httpClient.patch<OrderDetailResponse>(`/api/admin/orders/${id}/comment`, payload);
  }

  async delete(id: string): Promise<void> {
    await httpClient.delete<void>(`/api/admin/orders/${id}`);
  }

  async create(payload: CreateOrderDto): Promise<OrderDetailResponse> {
    const response = await httpClient.post<{ success: boolean; message: string; order: any }>('/api/admin/orders', payload);
    // Бэкенд возвращает структуру { success, message, order }
    // order уже содержит items и actions, но нужно убедиться что они не null
    return {
      order: {
        ...response.order,
        items: response.order.items || [],
        actions: response.order.actions || [],
      },
    };
  }
}

export const orderRepository = new OrderRepository();

